import React, { FC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Hint from '~/components/Hint';
import { useDirection } from '~/hooks/i18nHooks';
import direction from '~/utils/direction';

interface IProps {
  children?: React.ReactNode;
}

const WithPep: FC<IProps> = (props) => {
  const { children } = props;
  const dir = useDirection();
  return (
    <Container dir={dir}>
      {children}
      <PepHint />
    </Container>
  );
};

const PepHint = () => {
  const [t] = useTranslation('ksaApplication');
  return (
    <Hint
      text={t(
        'A PEP is an individual who holds a prominent public position or has held one in the recent past, making them susceptible to potential corruption and money laundering risks. PEPs include high-ranking government officials, their immediate family members, and close associates.'
      )}
    />
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .Hint {
    ${direction.margin.left(5)};
  }
`;

export default WithPep;
